export const PROTOCOL = window.PROTOCOL;
export const IP = window.API_IP;
export const PORT = window.API_PORT;
export const PATH = window.PATH;
export const BASE_URL = `${PROTOCOL}://${IP}:${PORT}${PATH}`;
